import { GiftLoading } from './GiftLoading'

export default GiftLoading
// eslint-disable-next-line import/export
export * from './GiftLoading'
